export default __webpack_public_path__ + "static/media/icon_right_simple_round_20_Regular.5abd9d06.svg";